// @flow

import React, { Component } from 'react';
import { Questions } from '../../assets/model';

type Props = {
  onNext: () => void,
  onChange: () => void,
  question: number
  // onComponentDidMount: () => void
};

type State = {
  street: string,
  number: string,
  zip: string,
  city: string
};

class Adress extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      street: '',
      number: '',
      zip: '',
      city: ''
    };
  }

  componentDidMount() {
    // this.props.onComponentDidMount();
  }

  _handleChange = event => {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    });

    let answerPath = '';

    switch (name) {
      case 'street':
        answerPath = 'street';
        break;
      case 'number':
        answerPath = 'streetNumber';
        break;
      case 'zip':
        answerPath = 'zip';
        break;
      case 'city':
        answerPath = 'city';
        break;

      default:
        break;
    }

    const reduxAnswer = {
      answerPath,
      value
    };

    this.props.onChange(this.props.question, reduxAnswer);
  };

  render() {
    return (
      <div className="main-transition-contianer">
        <div className="textField">
          <form onSubmit={this._handleSubmit}>
            <label>Straße</label>
            <br />
            <input
              name="street"
              type="text"
              value={this.state.name}
              onChange={event => {
                this._handleChange(event);
              }}
            />
            <br />
            <label>Hausnr.</label>
            <br />
            <input
              name="number"
              type="text"
              value={this.state.phone}
              onChange={event => {
                this._handleChange(event);
              }}
            />
            <br />
            <label>PLZ</label>
            <br />
            <input
              onChange={event => this._handleChange(event)}
              value={this.state.email}
              name="zip"
              type="text"
            />
            <br />
            <label>Ort</label>
            <br />
            <input
              onChange={event => this._handleChange(event)}
              value={this.state.email}
              name="city"
              type="text"
            />
            <br />
            <br />
            <br />
          </form>
          <p>
            Selbst in derselben Straße können Quadratmeterpreise stark
            schwanken. Geben Sie daher bitte unbedingt die vollständige Adresse
            inklusive der Hausnummer an.
          </p>
        </div>
        <div className="bottomBar">
          <div className="button" onClick={this.props.onNext}>
            Weiter
          </div>
        </div>
      </div>
    );
  }
}

export default Adress;



// WEBPACK FOOTER //
// ./src/components/questions/Adress.js